import { type LineCustomSvgLayer } from '@nivo/line'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { Fragment } from 'react'
import { type LineChartSeries } from './types'

export const LineChartCustomDot: LineCustomSvgLayer<LineChartSeries> = ({ series }) => {
    return series.map((serie) => {
        return serie.data
            .filter((point) => !point.data.isPrediction)
            .map((point) => (
                <Fragment key={`${serie.id}-${point.data.x}-${point.data.y}`}>
                    <circle
                        key={`${serie.id}-${point.data.x}`}
                        r={serie.smallDots ? 1.5 : 3.5}
                        strokeWidth={1}
                        cx={point.position.x}
                        cy={point.position.y}
                        stroke={serie.color}
                        fill={serie.dashedLine ? tokens.ColorGraphNeutralMedium : serie.color}
                    />
                    <text
                        x={point.position.x}
                        y={point.position.y - 10}
                        textAnchor="middle"
                        fill={tokens.ColorTextDefault}
                        fontSize={tokens.GraphLabel.fontSize}
                        fontFamily={tokens.GraphLabel.fontFamily}
                    >
                        {point.data.label}
                    </text>
                </Fragment>
            ))
    })
}
